export default "__VITE_ASSET__7127abdf__"